var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: { classes: "fadeInDown", delay: 0, duration: 300 },
          expression: "{ classes: 'fadeInDown', delay: 0, duration: 300 }",
        },
      ],
      staticClass: "action-palette",
    },
    [
      _c("div", { staticClass: "action-palette-top" }, [
        _c("div", { staticClass: "search-container" }, [
          _c("span", { staticClass: "material-icons search-icon" }, [
            _vm._v("search"),
          ]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchQuery,
                expression: "searchQuery",
              },
            ],
            staticClass: "search-input",
            attrs: { type: "text", placeholder: _vm.$t("wp.search") },
            domProps: { value: _vm.searchQuery },
            on: {
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.searchQuery = $event.target.value
              },
            },
          }),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticStyle: {
              display: "flex",
              "flex-direction": "row",
              "justify-content": "end",
            },
          },
          [
            _vm.bar !== 0
              ? _c("a-icon", {
                  staticStyle: { "font-size": "23px" },
                  attrs: { type: "close" },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("close-menu", 0)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.filteredActionPalette, function (ap, i) {
        return ap.enabled
          ? _c("div", { key: i }, [
              _c(
                "div",
                {
                  staticClass: "title",
                  staticStyle: { display: "flex", "align-items": "center" },
                  on: {
                    click: function ($event) {
                      return _vm.toggleAccordion(i)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.$t(
                          "chatbotv2." +
                            (ap.group.split(" ").length > 1
                              ? ap.group.split(" ").join("_")
                              : ap.group)
                        )
                      ) +
                      "\n            "
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "material-icons",
                      staticStyle: {
                        "margin-left": "auto",
                        "user-select": "none",
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.activeAccordion.includes(i)
                              ? "expand_less"
                              : "expand_more"
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.searchQuery.trim() ||
                        _vm.activeAccordion.includes(i),
                      expression:
                        "searchQuery.trim() || activeAccordion.includes(i)",
                    },
                  ],
                  staticClass: "items",
                },
                _vm._l(ap.items, function (subGroup, j) {
                  return (
                    subGroup.items
                      ? subGroup.items.some(function (item) {
                          return !item.disabled
                        })
                      : !subGroup.disabled
                  )
                    ? _c(
                        "div",
                        { key: j, staticClass: "sub-group" },
                        [
                          subGroup.group
                            ? _c("div", { staticClass: "sub-group-title" }, [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(
                                      _vm.$t(
                                        "chatbotv2." +
                                          subGroup.group.split(" ").join("_")
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(subGroup.items || [subGroup], function (item) {
                            return !item.disabled
                              ? _c(
                                  "button",
                                  {
                                    key: item.id,
                                    staticClass: "item chatbot-btn",
                                    attrs: { draggable: true },
                                    on: {
                                      dragstart: function (ev) {
                                        return _vm.dragStart(ev, item.id)
                                      },
                                      drag: function (ev) {
                                        return _vm.dragStart(ev, item.id)
                                      },
                                      dragend: function ($event) {
                                        return _vm.dragEnd()
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("BlockIconPreview", {
                                          staticClass: "img",
                                          staticStyle: { "font-size": "24px" },
                                          attrs: { "block-type": item.id },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex align-items-center align-content-center justify-content-start",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "blockTypeText" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.getBlockLabel(item))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e()
                          }),
                        ],
                        2
                      )
                    : _vm._e()
                }),
                0
              ),
            ])
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }